import React, {useEffect} from "react";
import {SelectField} from "./upperGroupMultipleSelectStyles";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {useObserver} from "mobx-react-lite";
import {groupBy} from "lodash";
import {arrayNaturalSort, compareArrays} from "../../../utils/helpers";

export const UpperGroupMultipleSelect = ({cities, upperGroups, setUpperGroups}) => {
    const stores = useStore();
    const {t} = useTranslation(["multipleSelect"]);
    const {OptGroup} = SelectField;

    const [upperGroupLoading, upperGroupData, setUpperGroupData, setUpperGroupLoading] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.regionStore.getUpperGroupsByCities.bind(null, {
            cities
        }),
        dependencies: [cities],
        condition: cities != null && cities != ""
    });

    useEffect(() => {
        if (!cities) {
            setUpperGroups([]);
        } else {
            const citiesArray = cities.split(",");
            const upperGroupCities = upperGroupData.map(upperGroup => upperGroup.city);
            if (cities && upperGroupData.length && !compareArrays(citiesArray, upperGroupCities)) {
                setUpperGroups([]);
            }
        }
    }, [cities, upperGroupData]);

    const renderUpperGroupsByCityGrouping = (upperGroupData, key) => {
        const groupByCity = groupBy(upperGroupData, "city");
        let cityKeys = Object.keys(groupByCity).map(city => city.capitalize());
        cityKeys = cityKeys.sort((a, b) => b - a);
        let grouped;
        if (groupByCity && upperGroupData != ["all"]) {
            grouped = cityKeys.map((city, i) => (
                <OptGroup
                    label={city}
                    key={i}
                    data-testid={`${key}Select_optionGroup`}
                    data-testvalue={city}
                >
                    {arrayNaturalSort(groupByCity[city.toLocaleLowerCase("tr-TR")], "group").map(
                        upperGroup => (
                            <SelectField.Option
                                key={upperGroup.group}
                                value={upperGroup.group}
                                data-testid={`${key}Select_optionGroup`}
                            >
                                {upperGroup.group}
                            </SelectField.Option>
                        )
                    )}
                </OptGroup>
            ));
        }
        return grouped;
    };

    return useObserver(() => (
        <>
            <h5>{t("fields.upperGroup", {ns: "common"})}</h5>
            <SelectField
                loading={upperGroupLoading}
                value={upperGroups}
                data-testid="upperGroupSelect"
                onChange={value => {
                    setUpperGroups(value);
                }}
                disabled={
                    cities == null ||
                    cities.length == 0 ||
                    upperGroupData == null ||
                    upperGroupData.length == 0 ||
                    upperGroupLoading
                }
                notFoundContent={t("filters.dataNotFound", {ns: "common"})}
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children
                        ?.toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                }
                mode={"multiple"}
                filterSort={(optionA, optionB) =>
                    optionA.children
                        ?.toString()
                        .toLowerCase()
                        .localeCompare(optionB.children?.toString().toLowerCase())
                }
            >
                <>{renderUpperGroupsByCityGrouping(upperGroupData, "region")}</>
            </SelectField>
        </>
    ));
};
